(function() {
  'use strict';

  angular.module('eclipseApp.myAccount')
  .factory('pricePlanInitiation', [
    '$log',
    '$q',
    'env',
    'prepaidUserInfoService',
    'commonService',
    '$http',
    'BFA_CONSTANTS',
    '$rootScope',
    '$stateParams',
    function(
      $log,
      $q,
      env,
      prepaidUserInfoService,
      commonService,
      $http,
      BFA_CONSTANTS,
      $rootScope,
      $stateParams
    ) {
      //default value
      var _bfaFlowType = BFA_CONSTANTS.PPC;
      var _bfaInProgress = false;
      var _selectedCTN;
      var _selectedBan;

      /**
       * Eligibility call returned successfully.
       * There might be a node-style error lurking, so throw that
       * @param  {Object} resp [server response]
       * @return {Object} resp
       * @throws {Object}
       */
      function _handleEligibilityFakeError(resp) {
        // node-style error return
        if (resp.error) {
          throw resp.error;
        }

        return resp;
      }

      function  _handleEligibilityResponse(resp) {

        var eligibility = resp.data;

        var elibilityKey = (_bfaFlowType === BFA_CONSTANTS.HUP) ? 'eligibility' : 'eligible';

        return resp;


      }

      /**
       * Save the choices the user makes on the dashboard
       * on the server, so the PPC page can retrieve it.
       * @param  {Object} resp [server response]
       * @return {Promise}
       */
      function _initiateSaveState(resp) {
        var groupedAccounts = _.groupBy(commonService.accountDetails, 'accountNumber');
        var currentAccount = groupedAccounts[commonService.wirelessAccountNumber];

        var currentAccountSubscriberServices = _.get(
          groupedAccounts,
          [
            '[',
             _selectedBan,
            ']',
            '[0]',
            '.subscriberServices'
          ].join('')
        );

        if (_.isEmpty(currentAccountSubscriberServices)) {
          throw new Error('Current account not found');
        }

        var subscriberNumbers = _.map(
          currentAccountSubscriberServices,
          'wireless.subscriberNo'
        );

        if (_.isEmpty(subscriberNumbers)) {
          throw new Error('Subscriber numbers not found');
        }

        var postData = {
          'applicationId': BFA_CONSTANTS.APPLICATION_ID,
          'eligibilityChecked': true,
          'availableCreditAmount': resp.availableCreditAmount,
          'accountNumber': _selectedBan,
          'ban': _selectedBan,
          'ctn': _selectedCTN,
          'accountTypeNumber': BFA_CONSTANTS.WIRELESS_IDENTIFIER,
          'ctnList': subscriberNumbers
        };

        var hupData = {
          'key': 'hupState',
          'ban': _selectedBan,
          'context': {
            'ctn': _selectedCTN,
            'ban': _selectedBan
          }
        };

        // send to PPC save state
        var ppcStatePromise = $http({
          'method': 'POST',
          'url': env.bfaURLs[BFA_CONSTANTS.PPC].saveState,
          'data': postData
        });

        var hupStatePromise;
        var retPromise;

        if (_bfaFlowType === BFA_CONSTANTS.HUP) {
          // hup-specific save state
          hupStatePromise = $http({
            'method': 'POST',
            'url': env.bfaURLs[BFA_CONSTANTS.HUP].saveState,
            'data': hupData
          });

          retPromise = $q.all([
            ppcStatePromise,
            hupStatePromise
          ]);
        }
        else {
          retPromise = ppcStatePromise;
        }

        return retPromise;
      }

      function _resetInProgress() {
        _bfaInProgress = false;
      }

      /**
       * Handle a failure from any of the previous promises
       * @param  {Object} err [might be an Error or other]
       */
      function _handleEligibilityFail(err) {
        _resetInProgress();
        $log.error('eligibility failed', err);

        throw err;
      }

      /**
       * Initializes the ATG cart
       */
      function _initiateATGCartInit() {
        var postData = {
          'applicationId': BFA_CONSTANTS.APPLICATION_ID,
          'ban': _selectedBan,
          'date': +new Date()
        };

        var url = (_bfaFlowType == BFA_CONSTANTS.PPC) ? env.bfaURLs.ppc.atgInit : env.bfaURLs.hup.atgInit;

        // Call ATG cart init
        return $http({
          'method': 'GET',
          'url': url,
          'params': postData
        });
      }

      /**
       * Initiate the process:
       *   eligibility check,
       *   save state on the server,
       *   initialize the ATG cart
       *   handle errors
       * @return {Promise}
       */
      function initiate(bfaFlowType, selectedCTN) {
        _bfaFlowType = bfaFlowType;
        _selectedCTN = selectedCTN;

        if (_bfaInProgress) {
          throw {
            suppressModal: true
          };
        }

        var postData = {
          'applicationId': BFA_CONSTANTS.APPLICATION_ID,
          'accountNumber': commonService.wirelessAccountNumber,
          'accountTypeNumber': BFA_CONSTANTS.WIRELESS_IDENTIFIER,
          // 'subscriberNumber': commonService.wirelessSubscriberNo,
          'subscriberNumber': _selectedCTN,
          'consolidatedInd': BFA_CONSTANTS.CONSOLIDATED_IND,
          'flowType': BFA_CONSTANTS.FLOW_TYPE
        };

        if (_bfaFlowType == BFA_CONSTANTS.HUP) {
          postData.phoneNumber = _selectedCTN;
        }

        var url = (_bfaFlowType == BFA_CONSTANTS.PPC) ? env.bfaURLs.ppc.eligibility : env.bfaURLs.hup.eligibility;

        _bfaInProgress = true;

        return $http({
          'method': 'POST',
          'url': url,
          'data': postData
        })
        .then(_handleEligibilityFakeError)
        .then(_handleEligibilityResponse)
        .then(_initiateSaveState)
        .then(_initiateATGCartInit)
        .then(_resetInProgress, _handleEligibilityFail);

      }


      function checkEligibility(bfaFlowType, selectedCTN, selectedBan, channelID) {
        _bfaFlowType = bfaFlowType;
        _selectedCTN = selectedCTN;
         _selectedBan = selectedBan ;
        var postData = {
          'applicationId': BFA_CONSTANTS.APPLICATION_ID,
          'accountNumber': _selectedBan,
          'accountTypeNumber': BFA_CONSTANTS.WIRELESS_IDENTIFIER,
          'subscriberNumber': _selectedCTN,
          'consolidatedInd': BFA_CONSTANTS.CONSOLIDATED_IND,
          'flowType': BFA_CONSTANTS.FLOW_TYPE
        };

        if (_bfaFlowType == BFA_CONSTANTS.HUP) {
          postData.phoneNumber = _selectedCTN;
        }

        var url = (_bfaFlowType == BFA_CONSTANTS.PPC) ? env.bfaURLs.ppc.eligibility : env.bfaURLs.hup.eligibility;

       /* _bfaInProgress = true;*/

        return $http({
          'method': 'POST',
          'url': url,
          'data': postData
        })
          .then(_handleEligibilityFakeError)
          .then(_handleEligibilityResponse)
      }

      function eligibilityProcessing(resp){
        return  $q.all([
           _initiateSaveState(resp),
           _initiateATGCartInit

         ]);


      }

      function handleBFAPermissionResponse(response) {
        var permissions = response.data && response.data.permissions ? response.data.permissions : null;
        var page_permission = {
            ppc : false, hup : false
        };

        page_permission.ppc = _.some(
            permissions,
            function(permission) {
                return (permission.permission === BFA_CONSTANTS.BRT_PPC_FLAG);
          }
        );
        page_permission.hup = _.some(
            permissions,
            function(permission) {
                return (permission.permission === BFA_CONSTANTS.BRT_HUP_FLAG);
          }
        );
        return page_permission;
      }

      function checkBFAPermission() {
        var url = (_bfaFlowType == BFA_CONSTANTS.PPC) ? env.bfaURLs.ppc.permissions : env.bfaURLs.hup.permissions;
        return $http(
          {
            'method': 'POST',
            'url': url
          }
        ).then(handleBFAPermissionResponse);
      }

      return {
        initiate: initiate,
        checkBFAPermission: checkBFAPermission,
        checkEligibility: checkEligibility,
        eligibilityProcessing: eligibilityProcessing
      };

    }
  ]);

  moduleConfig.registerModule('eclipseApp.myAccount.wireless.pricePlanInitiation', []);

})();
